import { Text } from 'react-native'
import { convertLineHeight, styled } from '~/utils'

export const Title = styled(Text, theme => {
  return {
    base: {
      flex: 1,
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.bold,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
    variants: {
      isDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
    },
  }
})
